@if (captureSnapshot.processing) {
  <span> Processing... </span>
} @else {
  @if (canDownload) {
    <a href="javascript:;" (click)="onDownloadClick()">
      {{ captureSnapshot.filename }}
    </a>
  } @else {
    <span> {{ captureSnapshot.status | titlecase }} </span>
  }
}
